<template>
  <!-- 应用管理 -->
  <div class="app-container bdc-app-manage-page">

    <div class="app-title bdc-app-manage-header-card">
      <div>
        <p class="bdc-app-manage-page-title">应用管理</p>
        <span class="bdc-app-manage-page-desc">应用管理页面主要是提供研发查看项目信息，<br>可以在此处获取 logstore 等相关参数进行配置，保证项目顺利接入</span>
      </div>
      <img src="@/assets/app-manage.png" alt="" class="bdc-app-manage-hero">
    </div>

    <div class="chart-container">
      <el-row :gutter="0">
        <el-col :span="24">
          <div class="bdc-app-manage-content">
            <el-form ref="form" :inline="false" :model="form" label-width="120px" label-position="right" class="yyform bdc-app-manage-form">
              <div class="bdc-app-manage-card bdc-app-manage-info-card">
                <div class="bdc-app-manage-info-body">
                  <div class="ibox-title bdc-app-manage-section-head">
                    <p class="bdc-app-manage-section-title">项目信息</p>
                    <el-button plain class="bdc-detail-btn" @click="seeDetail">查看详细信息</el-button>
                  </div>
                  <div class="bdc-app-manage-fields-grid">
                    <el-row class="bdc-form-grid-row">
                      <el-col :span="8">
                        <el-form-item label="应用名称" prop="name">
                          <el-input v-model="form.productName" size="mini" disabled placeholder="应用名称" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="研发方" prop="devParty">
                          <el-input v-model="form.devParty" size="mini" disabled placeholder="xxxx有限公司或英雄互娱xxxx工作室" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="运营方" prop="operateStudio">
                          <el-input v-model="form.operateStudio" size="mini" disabled placeholder="xxxx有限公司或英雄互娱xxxx工作室" />
                        </el-form-item>
                      </el-col>

                    </el-row>

                    <el-row class="bdc-form-grid-row">
                      <el-col :span="8">
                        <el-form-item label="合作方式">
                          <el-select v-model="form.cooperateType" size="mini" disabled placeholder="合作方式">
                            <el-option label="自研" :value="1" />
                            <el-option label="代理" :value="2" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="服务端开发语言">
                          <el-select v-model="form.devLanguage" size="mini" disabled multiple filterable placeholder="服务端开发语言">
                            <el-option v-for="item in devLanguagearr" :key="item.value" :label="item.key" :value="item.value" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="客户端开发语言">
                          <el-select v-model="form.devLanguageClient" size="mini" disabled multiple filterable placeholder="客户端开发语言">
                            <el-option v-for="item in devLanguageClientarr" :key="item.value" :label="item.key" :value="item.value" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div class="bdc-section-divider" />

                  <div class="bdc-logstore-block bdc-logstore-block--bdc">
                    <div class="bdc-logstore-header bdc-logstore-header--bdc">
                      <span class="bdc-app-manage-section-title">Logstore参数</span>
                      <div class="bdc-logstore-header__eyes">
                        <span v-if="!showLogtail" @click="showLogtailClick"><svg-icon icon-class="bdc-preview-close" class="icon bdc-logstore-eye" /></span>
                        <span v-if="showLogtail"><svg-icon icon-class="bdc-preview-open" class="icon bdc-logstore-eye" /></span>
                      </div>
                      <div v-if="showLogtail" class="bdc-logstore-header__hint bdc-logstore-header__hint--inline">
                        敏感数据已解锁，可查看{{
                  parseInt(form.ttl/60)>9?parseInt(form.ttl/60):'0'+parseInt(form.ttl/60)}}分{{form.ttl%60>9?form.ttl%60:'0'+form.ttl%60}}秒，倒计时结束后，为保护项目隐私，数据将重新隐藏，再次查看需重新验证
                      </div>
                      <div v-if="!showLogtail" class="bdc-logstore-header__hint bdc-logstore-header__hint--inline">
                        点击图标获取验证码，验证通过后可查看以下数据
                      </div>
                    </div>
                    <div class="bdc-app-manage-fields-grid" :class="{ ifSls: form.ifSls }">
                      <el-row :gutter="10" class="bdc-form-grid-row">
                        <el-col :span="8">
                          <el-form-item class="custom-label">
                            <template slot="label">
                              <span class="label-title">logProject</span>
                              <span class="label-text">(项目名)</span>
                            </template>
                            <el-input v-model="form.logProject" size="mini" disabled placeholder="项目名" />
                            <span v-if="showLogtail" class="bdc-field-copy" @click="copy($event, form.logProject || '')">
                              <svg-icon icon-class="copy" class="icon" />
                            </span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item class="custom-label">
                            <template slot="label">
                              <span class="label-title">logStore</span>
                              <span class="label-text">{{ currentGame.eventTrackVersion == 'v2.0' ? '(客户端正式环境库名)' : '(客户端库名)'
                          }}</span>
                            </template>
                            <el-input v-model="form.logStore" size="mini" disabled placeholder="客户端库名" />
                            <span v-if="showLogtail" class="bdc-field-copy" @click="copy($event, form.logStore)">
                              <svg-icon icon-class="copy" class="icon" />
                            </span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item class="custom-label">
                            <template slot="label">
                              <span class="label-title">logStoreServer</span>
                              <span class="label-text">{{ currentGame.eventTrackVersion == 'v2.0' ? '(服务端正式环境库名)' : '(服务端库名)'
                          }}</span>
                            </template>
                            <el-input v-model="form.serverLogStore" size="mini" disabled placeholder="服务端库名" />
                            <span v-if="showLogtail" class="bdc-field-copy" @click="copy($event, form.serverLogStore)">
                              <svg-icon icon-class="copy" class="icon" />
                            </span>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="10" class="bdc-form-grid-row">
                        <el-col :span="8">
                          <el-form-item label="accesskeyID">
                            <el-input v-model="form.accessKeyId" size="mini" disabled />
                            <span v-if="showLogtail" class="bdc-field-copy" @click="copy($event, form.accessKeyId)">
                              <svg-icon icon-class="copy" class="icon" />
                            </span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="accessKeySecret">
                            <el-input v-model="form.accessKeySecret" size="mini" disabled />
                            <span v-if="showLogtail" class="bdc-field-copy" @click="copy($event, form.accessKeySecret)">
                              <svg-icon icon-class="copy" class="icon" />
                            </span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="endpoint">
                            <el-input v-model="form.endpoint" size="mini" disabled />
                            <span v-if="showLogtail" class="bdc-field-copy" @click="copy($event, form.endpoint)">
                              <svg-icon icon-class="copy" class="icon" />
                            </span>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="10" class="bdc-form-grid-row">
                        <el-col :span="8">
                          <el-form-item label="AppKey">
                            <el-input v-model="form.appkey" size="mini" disabled placeholder="AppKey" />
                            <span v-if="showLogtail" class="bdc-field-copy" @click="copy($event, form.appkey)">
                              <svg-icon icon-class="copy" class="icon" />
                            </span>
                          </el-form-item>
                        </el-col>
                        <template v-if="currentGame.eventTrackVersion == 'v2.0'">
                          <el-col :span="8">
                            <el-form-item class="custom-label">
                              <template slot="label">
                                <span class="label-title">logStore_test</span>
                                <span class="label-text">(客户端测试环境库名)</span>
                              </template>
                              <el-input v-model="form.logstoreTest" size="mini" disabled placeholder="logstoreTest" />
                              <span v-if="showLogtail" class="bdc-field-copy" @click="copy($event, form.logstoreTest)">
                                <svg-icon icon-class="copy" class="icon" />
                              </span>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item class="custom-label">
                              <template slot="label">
                                <span class="label-title">logStoreServer_test</span>
                                <span class="label-text">(服务端测试环境库名)</span>
                              </template>
                              <el-input v-model="form.serverLogStoreTest" size="mini" disabled placeholder="serverLogStoreTest" />
                              <span v-if="showLogtail" class="bdc-field-copy" @click="copy($event, form.serverLogStoreTest)">
                                <svg-icon icon-class="copy" class="icon" />
                              </span>
                            </el-form-item>
                          </el-col>
                        </template>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>

            <template v-if="currentGame.eventTrackVersion == 'v2.0'">
              <div class="bdc-app-manage-card bdc-app-manage-logtail-card">
                <div class="bdc-logtail-switch-row bdc-logtail-switch-row--bdc">
                  <p class="bdc-app-manage-section-title">
                    是否使用logtail</p>
                  <el-switch v-model="form.openLogtail" :disabled="form.operaterLogtail==0" @change="openLogtail" />
                </div>
                <div class="bdc-logtail-info bdc-logtail-info--bdc">
                  <div class="bdc-logtail-desc">
                    <span>Logtail是日志服务提供的日志采集Agent，用于采集阿里云ECS、自建IDC、其他云厂商等服务器上的日志。详细介绍可点击查看</span>
                    <span class="bdc-text-link-with-arrow" @click="logDetail">
                      <span class="bdc-text-link-with-arrow__text">Logtail采集概述 (aliyun.com)</span>
                      <svg-icon icon-class="bdc-btn-arrow-single" class="bdc-text-link-with-arrow__icon" />
                    </span>
                  </div>
                  <div class="bdc-logtail-alert-row bdc-logtail-alert-row--bdc">
                    <span class="bdc-inline-alert bdc-inline-alert--bdc">
                      <svg-icon class="status-svg" icon-class="waring" />需注意：Logtail只采集增量日志</span>
                    <span>如果下发Logtail配置后，日志文件无更新，则Logtail不会采集该文件中的日志。如需采集历史日志，可使用Logtail自带的</span>
                    <span class="bdc-text-link-with-arrow" @click="logUploadDoc">
                      <span class="bdc-text-link-with-arrow__text">导入历史日志文件功能</span>
                      <svg-icon icon-class="bdc-btn-arrow-single" class="bdc-text-link-with-arrow__icon" />
                    </span>
                  </div>
                </div>
                <!-- 开启logtail后展示的内容 -->
                <template v-if="form.openLogtail">
                  <div class="bdc-logtail-toolbar bdc-logtail-toolbar--bdc">
                    <div class="bdc-logtail-toolbar__left">
                      <el-button v-if="form.operaterLogtail==1" type="primary" class="bdc-logtail-add-btn" icon="el-icon-plus" @click="addLogtail">添加Logtail配置</el-button>
                    </div>
                    <div class="bdc-logtail-toolbar__right"><span class="bdc-text-link-with-arrow bdc-logtail-guide-link" @click="showCreateGuidelines">
                        <span class="bdc-text-link-with-arrow__text">查看创建指引</span>
                        <svg-icon icon-class="bdc-btn-arrow-single" class="bdc-text-link-with-arrow__icon" />
                      </span>
                      <el-button v-if="form.operaterLogtail==1" class="icon-box bdc-logtail-refresh-btn" @click="refresh">
                        <svg-icon icon-class="refresh" class="icon" />
                      </el-button>

                    </div>
                  </div>
                  <div v-if="logtailTotal>0" class="bdc-monitor-row bdc-monitor-row--bdc">
                    <div class="bdc-monitor-group">
                      <el-popover placement="top-start" title="" width="500" trigger="hover">
                        <div>
                          <p>
                            平台会按设定频率定时请求阿里云日志服务，逐个获取并更新每条Logtail配置下IP的心跳状态。由于任务实际执行时间不可控，实际更新频率或受影响，请根据您的需求合理设置更新频率，以确保监测效果。
                          </p>
                          <p>注：IP心跳监测的更新频率必须 <span style="font-weight:700">小于</span> 日志采集状态监测的更新频率，且心跳监测的最小频率 <span style="font-weight:700">不能低于5分钟</span>。</p>
                        </div>
                        <span slot="reference" class="bdc-monitor-tip-trigger">
                          <BdcHelpIcon :size="15" />
                        </span>
                      </el-popover>
                      <span class="bdc-monitor-label">IP心跳监测 更新频率：</span>
                      <el-input-number v-model="heartbeatForm.interval" size="small" controls-position="right" class="bdc-monitor-input-number" placeholder="输入" :min="heartbeatForm.intervalUnit==0?5:0" :precision="0" :disabled="heartbeatForm.is_open" />
                      <el-select v-model="heartbeatForm.intervalUnit" size="small" class="bdc-monitor-select" :disabled="heartbeatForm.is_open">
                        <el-option label="分钟/次" :value="0" />
                        <el-option label="小时/次" :value="1" />
                      </el-select>

                      <el-button v-if="heartbeatForm.is_open && form.operaterLogtail==1" @click="heartbeatForm.is_open=false" type="text" class="bdc-monitor-action" size="small">修改</el-button>
                      <el-button v-if="!heartbeatForm.is_open" @click="heartbeatForm.is_open=true;getUpdateFrequency(0)" type="text" class="bdc-monitor-cancel" size="small">取消</el-button>
                      <el-button v-if="!heartbeatForm.is_open" @click="heartbeatOrcollectionSubmit(0)" type="text" class="bdc-monitor-action" size="small">确认</el-button>

                    </div>
                    <div class="bdc-monitor-group">

                      <el-popover placement="top-start" title="" width="500" trigger="hover">
                        <div>
                          <p>
                            平台会按设定频率定时请求阿里云日志服务，逐个获取并更新每条Logtail配置下IP的日志采集状态。由于任务实际执行时间不可控，实际更新频率或受影响，请根据您的需求合理设置更新频率，以确保监测效果。
                          </p>
                          <p>注：日志采集状态监测的更新频率必须 <span style="font-weight:700">大于</span> IP心跳监测的更新频率，且日志采集监测的最小频率 <span style="font-weight:700">不能低于10分钟</span>。</p>
                        </div>
                        <span slot="reference" class="bdc-monitor-tip-trigger">
                          <BdcHelpIcon :size="15" />
                        </span>
                      </el-popover>

                      <span class="bdc-monitor-label">IP日志采集状态监测 更新频率：</span>
                      <el-input-number v-model="collectionStatusForm.interval" size="small" controls-position="right" class="bdc-monitor-input-number" placeholder="输入" :min="collectionStatusForm.intervalUnit==0?10:0" :precision="0" :disabled="collectionStatusForm.is_open" />
                      <el-select v-model="collectionStatusForm.intervalUnit" size="small" class="bdc-monitor-select" :disabled="collectionStatusForm.is_open">
                        <el-option label="分钟/次" :value="0" />
                        <el-option label="小时/次" :value="1" />
                      </el-select>

                      <el-button v-if="collectionStatusForm.is_open && form.operaterLogtail==1" @click="collectionStatusForm.is_open=false" type="text" class="bdc-monitor-action" size="small">修改</el-button>

                      <el-button v-if="!collectionStatusForm.is_open" @click="collectionStatusForm.is_open=true;getUpdateFrequency(1)" type="text" class="bdc-monitor-cancel" size="mini">取消</el-button>
                      <el-button v-if="!collectionStatusForm.is_open" @click="heartbeatOrcollectionSubmit(1)" type="text" class="bdc-monitor-action" size="small">确认</el-button>
                    </div>
                    <div v-if="form.operaterLogtail==1" class="bdc-monitor-group">
                      <el-popover placement="top-start" title="" width="500" trigger="hover">
                        <div>
                          <p>开启时，当检测到logtail配置出现异常，会按照您设定的方式推送告警信息；</p>
                          <p>关闭时，出现异常情况则不会主动通知。</p>
                        </div>
                        <span slot="reference" class="bdc-monitor-tip-trigger">
                          <BdcHelpIcon :size="15" />
                        </span>
                      </el-popover>

                      <span class="bdc-monitor-label">是否开启监控告警：</span>
                      <span class="bdc-monitor-alarm-value">{{alarmForm.enabled==0?'已开启':'已关闭'}}</span>

                      <el-button type="text" class="bdc-monitor-action" size="small" @click="alarmSet">设置</el-button>

                    </div>
                  </div>
                  <el-table v-loading="logtailListLoading" :data="logtailList" class="grayTableTile" :border="false" style="width: 100%" @filter-change="filterChange">
                    <el-table-column prop="serverName" label="服务器名称" min-width="160" fixed="left" />
                    <el-table-column label="环境" min-width="80">
                      <template slot-scope="scope">
                        {{ scope.row.env == 'TEST' ? '测试服' : '正式服' }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="ip" label="IP(点击查看详情)" column-key="ipStatus" :filters="[{text: '正常', value: 2}, {text: '异常', value: 3}, {text: '已停用', value: 1}, {text: '创建中', value: 0},{text: '更新中', value: 6}]" :filter-multiple="true" min-width="200">
                      <template slot-scope="scope">

                        <div @click="showIpInfo(scope.row)" style="cursor: pointer;">
                          <div>
                            <span v-if="scope.row.delFlag == 6 || scope.row.delFlag == 0" class="bdc-logtail-ip-count">共{{scope.row.ipCount}}个</span>
                            <span v-else class="bdc-logtail-ip-count bdc-logtail-ip-count--active">共{{scope.row.ipCount}}个</span>

                          </div>
                          <div>
                            <span v-if="scope.row.delFlag == 3" class="bdc-label-icon-tag bdc-label-icon-tag--orange">
                              <svg-icon icon-class="bdc-icon-attention" class="bdc-label-icon-tag__icon" />{{scope.row.ipStatus}}</span>
                            <span v-if="scope.row.delFlag == 2" class="bdc-label-icon-tag bdc-label-icon-tag--green">
                              <svg-icon icon-class="bdc-icon-success" class="bdc-label-icon-tag__icon" />{{scope.row.ipStatus}}</span>
                            <span v-if="scope.row.delFlag == 1" class="bdc-logtail-ip-status-muted">已停用</span>
                            <span v-if="scope.row.delFlag == 0" class="bdc-logtail-ip-status-muted">创建中,请稍后刷新查看</span>
                            <span v-if="scope.row.delFlag == 6" class="bdc-logtail-ip-status-muted">{{scope.row.ipStatus}}</span>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="logFilepath" label="日志路径" min-width="160" />
                    <el-table-column prop="remark" label="备注" show-overflow-tooltip min-width="160" />
                    <el-table-column label="更新时间" min-width="170">
                      <template slot="header" slot-scope="scope">
                        <span>更新时间</span>
                        <el-popover placement="top" width="500" trigger="hover" content="【logtail配置】模块为BDC4平台V4.2.4版本新增的功能，此处更新时间显示为2023-08-29的logtail配置，均是从阿里云后台同步的历史已创建的采集程序，非实际创建/更新时间，仅供参考">
                          <span slot="reference" class="bdc-table-header-tip-trigger">
                            <BdcHelpIcon :size="15" />
                          </span>
                        </el-popover>
                      </template>
                      <template slot-scope="scope">
                        <span>{{ scope.row.updateTime }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="updateUser" label="最后修改人" min-width="110" />

                    <el-table-column label="操作" width="230">
                      <template slot-scope="scope">
                        <div class="bdc-table-op-cell">
                          <template v-if="form.operaterLogtail==1">

                            <el-button v-if="scope.row.delFlag == 1 " type="text" class="bdc-table-op-muted" :disabled="true">已停止</el-button>
                            <template v-else>
                              <el-button type="text" class="bdc-table-op-muted" :disabled="scope.row.delFlag == 0 || scope.row.delFlag == 6" @click="editLogtail(scope.row)">编辑</el-button>
                              <el-button type="text" class="bdc-table-op-muted" :disabled="scope.row.delFlag == 0 || scope.row.delFlag == 6" @click="delLogtail(scope.row)">停止</el-button>
                            </template>
                          </template>
                          <el-button :disabled="scope.row.delFlag == 6" type="text" class="bdc-table-op-primary" @click="logtailHistory(scope.row)">变更历史</el-button>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>

                  <bdc-table-footer>
                    <pagination v-show="logtailTotal > 0" :auto-scroll="false" :background="false" :total="logtailTotal" :page.sync="pageNo" :limit.sync="pageSize" :page-sizes="[10, 15, 20, 30, 50]" class="bdc-table-pagination" @pagination="handleLogtailPagination" />
                  </bdc-table-footer>
                </template>
              </div>
            </template>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog class="dialog" custom-class="bdc-logtail-dialog" width="800px" :title="(logtailFormTmp.ip && logtailFormTmp.ip != '') ? '编辑logtail配置' : '添加logtail配置'" :close-on-click-modal="false" :visible.sync="logtailDia" top="10vh">
      <div class="bdc-logtail-dialog__body">
        <div class="bdc-logtail-steps">
          <steps :stepsIndex="createGuidelinesActive" :stepsData="createGuidelinesList" @clickStep="clickStep" />
        </div>
        <div v-if="createGuidelinesActive==0" class="bdc-logtail-dialog__desc">
          请务必仔细阅读以下说明，并按照指示操作，这将帮助您更顺利地完成logtail的安装和启动，本地完成操作后，可点击右下角按钮进入下一步。</div>
        <div v-if="createGuidelinesActive==1" class="bdc-logtail-dialog__desc">
          请务必仔细阅读以下说明，并按照指示操作，这将帮助您更顺利地在服务器上配置阿里云账号ID为用户标识，本地完成操作后，可点击右下角按钮进入下一步。</div>
        <el-alert v-if="createGuidelinesActive==0" class="bdc-logtail-dialog__alert" type="warning" show-icon :closable="false">
          <div style="line-height: 20px;">
            <div>如果已经安装过logtail，本次操作时也需要再重新安装。</div>
            <div>本平台操作<b>仅支持Linux系统</b>，如需要其他环境，请飞书联系<b>【BDC助手】</b>，我们将为您提供进一步的帮助。</div>
          </div>
        </el-alert>
        <el-alert v-if="createGuidelinesActive>0&&createGuidelinesActive<createGuidelinesList.length-1" class="bdc-logtail-dialog__alert" type="warning" show-icon :closable="false">
          <div style="line-height: 20px;">
            <div>本平台操作<b>仅支持Linux系统</b>，如需要其他环境，请飞书联系<b>【BDC助手】</b>，我们将为您提供进一步的帮助。</div>
          </div>
        </el-alert>
        <el-alert v-if="createGuidelinesActive==createGuidelinesList.length-1 && logtailType=='edit'" class="bdc-logtail-dialog__alert" type="warning" show-icon :closable="false">
          <div style="line-height: 20px;">
            <div>如果您需要 <b>修改IP</b>，请点击上一步，<b>仔细查阅前两步的内容</b>，以确保新的IP获取及填写无误，避免修改后出现异常情况。</div>
          </div>
        </el-alert>
        <div class="bdc-logtail-dialog__guide-frame" v-if="createGuidelinesActive<createGuidelinesList.length-1">
          <div v-for="(item,index) in createGuidelinesList" :key="index">
            <template v-if="createGuidelinesActive == index">
              <iframe class="bdc-guide-iframe" height="230px" width="100%" :srcdoc="getBdcGuideSrcdoc(item.html)"></iframe>
            </template>
          </div>
        </div>
        <el-form v-if="createGuidelinesList.length-1 == createGuidelinesActive" ref="logtailFormRef" :model="logtailForm" :rules="logtailRules" class="bdc-logtail-form">
          <el-form-item prop="serverName">
            <template slot="label">服务器名称</template>
            <el-input v-model="logtailForm.serverName" :disabled="logtailFormTmp.ip && logtailFormTmp.ip != ''" placeholder="请输入服务器名称" />
            <div class="bdc-logtail-form__hint">
              名称只能包含小写字母、数字、短划线(-)和下划线(_)且必须以小写字母或数字开头和结尾，长度为3~128字节</div>
          </el-form-item>
          <el-form-item prop="env">
            <template slot="label">环境</template>
            <el-select v-model="logtailForm.env" placeholder="请选择环境" :disabled="logtailFormTmp.ip && logtailFormTmp.ip != ''">
              <el-option label="测试服" value="TEST" />
              <el-option label="正式服" value="MASTER" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <template slot="label"><span class="bdc-logtail-form__required">*</span> IP</template>
            <div class="ipInput bdc-logtail-form__ip-input" @click="showIpInput">
              <div class="ipTag">
                <el-tag class="bdc-logtail-form__ip-tag" v-for="(item,index) in ipList" :key="index" :disable-transitions="true" :closable="true" @close="handleCloseTag(item)">{{item}}</el-tag>
              </div>
              <span v-if="ipList.length==0" class="bdc-logtail-form__ip-placeholder">点击查看IP地址获取说明并添加IP</span>
            </div>

          </el-form-item>
          <el-form-item prop="logPath">
            <template slot="label">日志路径</template>
            <div class="bdc-logtail-form__path-row">
              <el-input v-model="logtailForm.logPath" placeholder="日志路径" />
              <span class="bdc-logtail-form__path-sep">/* */</span>
              <el-form-item prop="filePattern" label-width="0" class="bdc-logtail-form__pattern-item">
                <el-input v-model="logtailForm.filePattern" placeholder="格式" />
              </el-form-item>
            </div>
          </el-form-item>
          <div class="bdc-logtail-form__path-hint">
            指定文件夹下所有符合文件名称的文件都会被监控到（包含所有层次的目录），文件名称可以是完整名，也支持通配符模式匹配，支持使用环境变量，如${install_path}/log。Linux文件路径只支持“/”开头，例：/apsara/nuwa/…/app.Log，Windows文件路径只支持盘符开头，例如:
            C:\Program Files\Intel\…\*.Log
          </div>

          <el-form-item prop="remark">
            <template slot="label">备注</template>
            <el-input v-model="logtailForm.remark" type="textarea" :rows="4" placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="bdc-logtail-dialog__footer">
        <el-button v-if="createGuidelinesActive==0" plain class="bdc-dialog-btn-outline" @click="createGuidelinesActive = createGuidelinesList.length-1">跳过指引步骤</el-button>

        <el-button v-if="createGuidelinesActive>0" plain class="bdc-dialog-btn-outline" @click="prevSteps">上一步</el-button>
        <el-button plain class="bdc-dialog-btn-outline" @click="cancelLogtailDia">取消</el-button>

        <el-button v-if="createGuidelinesActive<createGuidelinesList.length-1" type="primary" class="bdc-dialog-btn-primary" @click="nextSteps">下一步</el-button>
        <template v-if="createGuidelinesActive==createGuidelinesList.length-1">
          <el-button v-if="!logtailFormTmp.ip" type="primary" class="bdc-dialog-btn-primary" @click="handleCreateLogtail" :loading="editLoading">创建</el-button>
          <el-button v-else type="primary" class="bdc-dialog-btn-primary" @click="handelEditConfirm(false)" :loading="editLoading">提交修改</el-button>
        </template>
      </div>
    </el-dialog>
    <!-- 删除编辑logtail弹窗 -->
    <el-dialog :visible.sync="confirmDia" append-to-body width="460px" custom-class="bdc-logtail-confirm-dialog" title="提示">
      <div class="bdc-logtail-confirm-dialog__body">
        <i class="el-icon-warning bdc-logtail-confirm-dialog__icon" />
        <div v-if="confirmType == 'edit'">
          <div class="bdc-logtail-confirm-dialog__text">
            您即将对当前Logtail配置的IP地址进行更新：
          </div>
          <div class="bdc-logtail-confirm-dialog__text">
            请注意，修改IP后，Logtail机器组将重新建立心跳连接；在此期间，IP字段将显示为‘更新中’，大约2分钟后可刷新列表查看更新结果。
          </div>
          <div class="bdc-logtail-confirm-dialog__text">
            是否确认提交修改？
          </div>
        </div>
        <div v-else class="bdc-logtail-confirm-dialog__text">
          停止后，此条logtail配置会从阿里云后台删除，将停止在此条logtail配置下的日志采集程序，历史已采集的日志仍会保留，是否确认停止？
        </div>
      </div>

      <div slot="footer" class="bdc-logtail-dialog__footer">
        <el-button plain class="bdc-dialog-btn-outline" @click="confirmDia = false">取消</el-button>
        <el-button type="primary" class="bdc-dialog-btn-primary" @click="confirmType == 'edit' ? handelEditConfirm(true) : handleDelLogtail(confirmType)">我已确认</el-button>
      </div>
    </el-dialog>

    <!-- logtail变更历史 -->
    <el-dialog :visible.sync="logHistoryDia" append-to-body width="1200px" custom-class="bdc-logtail-history-dialog" :title="`变更历史${logHistoryList.row.serverName}`" :close-on-click-modal="false">
      <template v-if="logHistoryList.originData.length">
        <el-table :data="logHistoryList.data" height="500px" class="grayTableTile" :border="false" @sort-change="logHistorySort">
          <el-table-column sortable="custom" prop="updateTime" label="变更时间" min-width="160" />
          <el-table-column prop="updateUser" label="修改人" min-width="95" />
          <el-table-column label="变更类型" min-width="140">
            <template slot-scope="scope">
              {{ scope.row.updateType == 1 ? '添加logtail配置' : scope.row.updateType == 2 ? '修改logtail配置' :
              scope.row.updateType == 3 ? '停用logtail配置' : scope.row.updateType == 5 ? 'ip心跳状态变更' : scope.row.updateType
              == 6 ? 'ip日志采集状态变更' : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="变更字段" min-width="140">
            <template slot-scope="scope">
              <span v-html="scope.row.updateFieldsStr" />
            </template>
          </el-table-column>
          <el-table-column label="变更前" min-width="240">
            <template slot-scope="scope">
              <!-- <span v-html="scope.row.updateBeforeStr" /> -->
              <div v-for="(text, index) in scope.row.updateBeforeStr.split('<br/>')" :key="index" :title="text" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                {{ text }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="变更后" min-width="240">
            <template slot-scope="scope">
              <!-- <span v-html="scope.row.updateAfterStr" /> -->
              <div v-for="(text, index) in scope.row.updateAfterStr.split('<br/>')" :key="index" :title="text" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                {{ text }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="变更后状态">
            <template slot-scope="scope">
              {{ scope.row.status == 0 ? '创建中' : scope.row.status == 1 ? '创建成功' : '创建失败' }}
            </template>
          </el-table-column> -->
        </el-table>
        <bdc-table-footer>
          <pagination :key="logHistoryPagerKey" :auto-scroll="false" :background="false" :total="logHistoryList.originData.length" :page.sync="logHistoryParam.pageNo" :limit.sync="logHistoryParam.pageSize" class="bdc-table-pagination" @pagination="getLogtailHistory" />
        </bdc-table-footer>

      </template>
      <div v-else style="display: flex;align-items: center;justify-content: center;padding: 80px;flex-direction: column;">
        <img src="../../../../../src/assets/empty.png" alt="" style="width: 110px;height: 90px;margin-top: -24px;">
        <span style="color: #999;margin-top: 20px;">暂无变更历史</span>
      </div>
    </el-dialog>

    <!-- 查看游戏详情 -->
    <create-game ref="create" @getAgainList="productinfodata" />

    <!-- 查看创建指引 -->
    <el-drawer title="查看创建指引" :visible.sync="createGuidelinesVisible" direction="rtl" size="800px" :show-close="false" :append-to-body="true">
      <el-scrollbar class="scrollCreateGuidelines" :style="{'height':'calc(100vh - 150px )'}">
        <div style="padding:0px 20px">
          <div style="font-weight: 400;font-size: 14px;color: #999999;line-height: 22px;margin-bottom:16px">
            以下内容为添加logtail配置时的主要步骤，包括如何安装logtial、配置用户标识等基础操作说明，以便帮助您快速了解添加logtail配置的相关内容。</div>
          <el-alert class="centerAlert1" type="warning" show-icon :closable="false">
            <div style="line-height: 20px;">
              <div>本平台操作<b>仅支持Linux系统</b>，如需要其他环境，请飞书联系<b>【BDC助手】</b>，我们将为您提供进一步的帮助。</div>
            </div>
          </el-alert>

          <div style="margin-top:24px">
            <div v-for="(item,index) in createGuidelinesListLook" :key="index">
              <div style="font-weight: 600;font-size: 16px;color: #333333;margin-bottom:16px">
                {{item.Subtitle}}{{item.title}}</div>
              <iframe v-if="index<createGuidelinesListLook.length-1" class="bdc-guide-iframe" height="230px" width="100%" :srcdoc="getBdcGuideSrcdoc(item.html)"></iframe>

              <div v-else style="font-size: 14px;color: #333333;">根据表单内容填写详细信息，并点击创建即可完成logtail配置的添加操作。</div>
            </div>
          </div>

        </div>
      </el-scrollbar>
      <div class="drawerFooter">
        <div></div>
        <el-button plain style="border: 1px solid #3A89FF;color: #3A89FF;" @click="createGuidelinesVisible = false">关
          闭</el-button>
      </div>
    </el-drawer>

    <!-- 批量添加IP -->
    <el-drawer title="添加IP" :visible.sync="ipInputVisible" direction="rtl" size="700px" :wrapperClosable="false" :show-close="false" :append-to-body="true">
      <el-scrollbar class="scrollCreateGuidelines" :style="{'height':'calc(100vh - 150px )'}">
        <div style="padding:0px 24px">
          <div style="font-weight: 600;font-size: 16px;color: #333333;margin-bottom:16px">1. 获取服务器IP地址可查看下方说明</div>
          <!-- <div style="background: #F9F9F9;border: 1px solid #E5E5E5;padding:0px 20px;margin-bottom:24px" v-html="'<p>aaaa</p><br/><p>aaaa</p>'"></div> -->
          <iframe class="bdc-guide-iframe" height="480px" width="100%" :srcdoc="getBdcGuideSrcdoc(IpHtml)"></iframe>

          <div style="font-weight: 600;font-size: 16px;color: #333333;margin-bottom:16px">2. 添加IP地址</div>
          <div style="display: flex;flex-flow: row nowrap;justify-content: space-between;align-items: center;">
            <div style="font-weight: 400;font-size: 14px;color: #999999;">最多支持添加100个IP地址，使用回车换行分隔（如需添加更多ip，可创建多条logtail配置）</div>
            <el-link :underline="false" type="primary" :disabled="textStr==''" @click="copyIp($event)">全选复制</el-link>
          </div>
          <div style="height:240px;margin-top:16px">
            <el-input type="textarea" :rows="20" v-model="textStr" placeholder="每条之间敲击回车键换行"></el-input>
            <!-- <edit-rows v-if="ipInputVisible" ref="editRow" :max="10" :inputLength="15" isRepeat :oldArr="ipList" :label="'IP'"></edit-rows> -->
          </div>
        </div>
      </el-scrollbar>
      <div class="drawerFooter">
        <div></div>
        <el-button plain style="border: 1px solid #3A89FF;color: #3A89FF;" @click="closeIpInput">关 闭</el-button>
        <el-button type="primary" @click="querenIpInput">保 存</el-button>
      </div>
    </el-drawer>

    <!-- 日志检测情况 -->
    <el-drawer :title="logCheckTitle" :visible.sync="logCheckVisible" direction="rtl" size="700px" :show-close="false" :append-to-body="true">
      <el-scrollbar class="scrollCreateGuidelines" :style="{'height':'calc(100vh - 150px )'}">
        <div style="padding:0px 20px">
          <div v-if="logCheckType == 'errorReason'" style="font-weight: 400;font-size: 14px;color: #333;line-height: 22px;margin-bottom:16px">
            logtail心跳创建失败可能由以下原因导致，您可以根据以下提示步骤进行排查<br />若排查后仍未解决问题，请飞书联系<span style="font-weight: 600;">【BDC助手】</span>进行反馈</div>
          <div v-if="logCheckType == 'errorCheck'" style="font-weight: 400;font-size: 14px;color: #333;line-height: 22px;margin-bottom:16px">
            Logtail配置创建成功后，如果采集状态中没有检测到日志，您可以根据以下提示步骤进行排查<br />若排查后仍未解决问题，请飞书联系<span style="font-weight: 600;">【BDC助手】</span>进行反馈</div>
          <div style="margin-top:24px">
            <div v-for="(item,index) in logCheckList" :key="index">
              <iframe v-if="index==currentIndex" class="bdc-guide-iframe" height="690px" width="100%" :srcdoc="getBdcGuideSrcdoc(item.html)"></iframe>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div class="drawerFooter">
        <div></div>
        <div>
          <el-button plain style="border: 1px solid #3A89FF;color: #3A89FF;" v-if="currentIndex>0&&currentIndex<logCheckList.length" @click="currentIndex--">上一步</el-button>
          <el-button plain style="border: 1px solid #3A89FF;color: #3A89FF;" @click="logCheckVisible = false;currentIndex=0">关 闭</el-button>
          <el-button v-if="currentIndex==logCheckList.length-1" type="primary" @click="logCheckVisible = false;currentIndex=0">完 成</el-button>
          <el-button v-if="currentIndex<logCheckList.length-1" type="primary" @click="currentIndex++">下一步</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 告警设置 -->
    <el-dialog title="监控告警设置" :visible.sync="alarmVisible" append-to-body width="428px" :close-on-click-modal="false" @close="alarmGuanbi">
      <div style="font-size: 12px;color: #999999;line-height: 20px;padding-left: 24px;padding-bottom: 10px;">
        告警开启时，当检测到logtail配置出现异常，会按照您设定的方式推送告警信息；告警关闭时，出现异常则不会主动推送告警信息。
      </div>
      <el-form ref="alarmFormRef" :model="alarmForm" label-position="right" label-width="120px">
        <el-form-item label="是否开启告警">
          <el-switch v-model="alarmForm.enabled" :active-value="0" :inactive-value="1" @change="enabledChange"></el-switch>
        </el-form-item>
        <el-form-item label="静默时间">
          <el-input-number v-model="alarmForm.muteDuration" controls-position="right" style="width: 100px" placeholder="输入" :min="0" :precision="0" />
          <el-select v-model="alarmForm.muteDurationUnit" style="width: 100px">
            <el-option label="分钟" :value="0" />
            <el-option label="小时" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="告警方式">
          <el-checkbox-group v-model="alarmForm.alertChannel">
            <el-checkbox label="feishu" style="margin-right:15px" v-if="isFeishu">飞书</el-checkbox>
            <el-checkbox label="email" style="margin-right:15px" v-if="isEmail">邮件</el-checkbox>
            <el-checkbox label="sms" style="margin-right:15px" v-if="isPhone">短信</el-checkbox>
            <el-checkbox label="phone" style="margin-right:15px" v-if="isPhone">电话</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: -30px;">
        <el-button plain style="border: 1px solid #3A89FF;color: #3A89FF;" @click="alarmGuanbi">取消</el-button>
        <el-button type="primary" :loading="alarmSubmitLoading" @click="alarmSubmit">确认</el-button>
      </div>
    </el-dialog>

    <!-- 二次验证 -->
    <el-dialog title="验证码" :visible.sync="codeVisible" append-to-body width="428px" :close-on-click-modal="false">
      <div v-if="codePass == 1" style="font-size: 14px;color: #666666;line-height: 14px;padding-bottom: 20px;margin-left: 20px;">
        <div v-if="codePhone!=''">验证码已发送至尾号{{codePhone}}的手机，请输入验证：</div>
        <div v-else>验证码已发送至您账号绑定的邮箱，请输入验证：</div>
      </div>
      <div v-else style="font-size: 14px;color: #333;line-height: 14px;padding-bottom: 10px;margin-left: 20px;">
        <div style="display: flex;align-items: center;"><svg-icon icon-class="error" class="icon" style="width: 20px;height: 20px;" />&nbsp;&nbsp;验证码错误，请重试</div>
      </div>
      <div style="position: relative;width: 280px;margin-left: 20px;">
        <el-input v-model="codeInput" style="width: 280px" placeholder="请输入验证码" />
        <div style="position: absolute;right: 10px;top: 10px;">
          <div v-if="codeTime == 60" style="font-size: 14px;color: #3A89FF;cursor: pointer;" @click="getCode">点击获取验证码
          </div>
          <div v-else style="font-size: 14px;color: #999;">{{codeTime}}s后重新获取</div>
        </div>
      </div>
      <div slot="footer" style="margin-top: 0px;">
        <el-button plain style="border: 1px solid #3A89FF;color: #3A89FF;" @click="codeVisible = false">取消</el-button>
        <el-button type="primary" @click="codeSubmit">提交验证</el-button>
      </div>
    </el-dialog>

    <!-- ip列表 -->
    <el-dialog :title="ipTitle" :show-close="false" :visible.sync="ipVisible" append-to-body width="980px" custom-class="bdc-ip-detail-dialog" :close-on-click-modal="false">
      <el-button v-if="form.operaterLogtail==1" class="icon-box bdc-logtail-refresh-btn bdc-ip-detail-refresh-btn" @click="ipRefresh">
        <svg-icon icon-class="refresh" class="icon" />
      </el-button>
      <el-table :data="ipInfoList" :row-style="{ height: '44px', color: '#666' }" :header-cell-style="{background:'#F7F7F7', height: '44px'}" max-height="500" v-loading="ipListLoading">
        <el-table-column prop="xuhaoId" label="序号" min-width="70" />
        <el-table-column prop="ip" label="IP" min-width="150"></el-table-column>
        <el-table-column prop="status" label="心跳" min-width="170">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 1">OK</div>
            <div v-if="scope.row.status == 2" @click="showErrorInfo(scope.row,'errorReason')" style="cursor: pointer;">
              <div style="font-size: 14px;color: #E22B4B;"><svg-icon class="status-svg" icon-class="error" style="width:14px;height:14px;margin-right:3px" />FAIL</div>
              <div class="bdc-ip-reason-link">点击查看原因</div>
            </div>
            <div style="font-size: 14px;color:#999999" v-if="scope.row.status == 0">创建中</div>
            <div v-if="scope.row.status == 3" style="color: #666666;">-</div>
          </template>
        </el-table-column>
        <el-table-column prop="ipCheckTime" label="最后心跳时间" min-width="170">
          <template slot="header" slot-scope="scope">
            <span>最后心跳时间</span>
            <el-popover placement="top" width="500" trigger="hover">
              <div style="font-size: 12px;">记录定时监测任务最后一次获取到IP心跳的时间</div>
              <i slot="reference" class="el-icon-warning" style="color: #abadb2;cursor: pointer; font-size:16px; vertical-align: middle;" />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="collectStatus" label="日志采集状态" min-width="170">
          <template slot="header" slot-scope="scope">
            <span>日志采集状态</span>
            <el-popover placement="top" width="600" trigger="hover">
              <div style="font-size: 12px;">
                记录定时监测任务获取的日志采集情况，共有以下几种情况：<br />
                （1）已检测到采集：表示在最近24小时内该IP有成功采集到日志数据；<br />
                （2）未检测到日志：表示在该IP地址下，Logtail未采集到任何日志数据；<br />
                （3）日志采集停滞：表示在该IP地址下曾成功采集日志，但最近24小时内没有采集到新的日志数据；<br />
                （4）待监测更新：表示该IP地址为新增项，其日志采集状态尚未通过定时监测获取，日志采集状态将在后续监测中更新；<br />
                （5）心跳异常，无法采集：logtail与该IP地址的心跳连接失败，无法采集日志，因此无采集状态
              </div>
              <i slot="reference" class="el-icon-warning" style="color: #abadb2;cursor: pointer; font-size:16px; vertical-align: middle;" />
            </el-popover>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0 || scope.row.status == 3" style="font-size: 14px;color: #999999;">-</div>
            <div v-if="scope.row.status == 2" style="font-size: 14px;color: #999999;">心跳异常，无法采集</div>
            <div v-if="scope.row.status == 1" style="font-size: 14px;">
              <div v-if="scope.row.collectStatus == 0" style="color: #666666;">已检测到采集</div>
              <div v-else-if="scope.row.collectStatus == 1 || scope.row.collectStatus == 2" @click="showErrorInfo(scope.row,'errorCheck')" style="cursor: pointer;">
                <div style="color:#FF963E;"><svg-icon class="status-svg" icon-class="waring" style="width:14px;height:14px;margin-right:3px" />{{scope.row.collectStatus ==
                  1?"异常：日志采集停滞":"异常：未检测到日志"}}</div>
                <div class="bdc-ip-reason-link">
                  点击查看原因
                </div>
              </div>
              <div v-if="scope.row.collectStatus == 3" style="color: #666666;">-</div>
              <div v-if="scope.row.collectStatus == 5" style="color: #666666;">待监测更新</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="collectTime" label="最后采集时间" min-width="170">
          <template slot="header" slot-scope="scope">
            <span>最后采集时间</span>
            <el-popover placement="top" width="400" trigger="hover">
              <div style="font-size: 12px;">记录定时监测任务最后一次获取到日志采集成功的时间</div>
              <i slot="reference" class="el-icon-warning" style="color: #abadb2;cursor: pointer; font-size:16px; vertical-align: middle;" />
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer">
        <el-button type="primary" @click="ipVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 关闭弹窗 -->
    <el-dialog :visible.sync="guanbiDia" append-to-body width="460px" :show-close="false">
      <div style="display: flex;">
        <i class="el-icon-warning" style="font-size: 24px; color: #ff963e; vertical-align: middle; margin-right: 8px;margin-top: -4px;" />
        <div style="font-size: 16px;color: #333333;">
          当前项目下存在正在运行的Logtail配置，无法关闭 Logtail 功能，请先停止所有的logtail配置，再进行操作
        </div>
      </div>

      <div style="display: flex;justify-content: flex-end;margin-top: 40px;">
        <el-button type="primary" @click="guanbiDia = false">我已知晓</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  productinfo,
  productinfovalue,
  open_logtail,
  add_logtail,
  query_logtail,
  edit_logtail,
  delete_logtail,
  query_logtailHistory,
  logtailPromptType,
  logtailCollectStatus,
  query_logtailIp,
  query_logtailIpRefresh,
  query_logtailAlertGetjob,
  query_logtailAlertSavejob,
  query_logtailAlertRule,
  query_logtailAlertSave,
  gameSendCode,
  gameVerifyCode,
  query_logtailIsClosed
} from '@Bdc~/api/ajax_model'

import CreateGame from '@Sys~/views/youxizhongxin/components/createGame'
import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'

import { sortKeys } from '@/filters'
import clipboard from '@Sys~/utils/clipboard'
import Steps from '@/components/Steps'
import EditRows from '@/components/EditRows'
import BdcHelpIcon from '@/components/BdcHelpIcon'


// ip地址校验
var IPValidator = (rule, value, callback) => {
  const ip_ip = '(25[0-5]|2[0-4]\\d|1\\d\\d|\\d\\d|\\d)'
  const ip_ipdot = ip_ip + '\\.'
  const isIPaddress = new RegExp('^' + ip_ipdot + ip_ipdot + ip_ipdot + ip_ip + '$')
  if (value && !isIPaddress.test(value)) {
    callback(new Error('IP地址格式错误'))
  } else {
    callback()
  }
}

export default {
  name: '',
  components: { Pagination, BdcTableFooter, CreateGame, Steps, EditRows, BdcHelpIcon },
  filters: {},
  data() {
    const filePatternValidator = (rule, value, callback) => {
      // your code
      if (!value) {
        callback(new Error('请输入日志路径'))
      } else {
        callback()
      }
    }
    const validateName = (rule, value, callback) => {
      const encoder = new TextEncoder()
      const bytes = encoder.encode(value)

      if (bytes.length < 3 || bytes.length > 128) {
        callback(new Error('名称长度为3\~128字节'))
      } else {
        const reg = /^[a-z0-9][a-z0-9_-]*[a-z0-9]$/
        if (!reg.test(value)) {
          callback(new Error('名称格式错误'))
        } else {
          callback()
        }
      }
    }
    return {
      guanbiDia: false,
      textStr: "",
      isUpdate: window.sessionStorage.getItem('isUpdate'), // 是否可编辑
      checked: false,
      form: {
        id: '',
        name: '',
        devParty: '',
        operateStudio: '',
        cooperateType: '',
        devLanguage: '',
        devLanguageClient: '',

        logProject: '',
        logStore: '',
        serverLogStore: '',
        accessKeyId: '',
        accessKeySecret: '',
        endpoint: '',
        appkey: '',

        logstoreTest: '',
        serverLogStoreTest: '',
        operateLogtail: '',

        ttl: 0,
      },

      logHistoryDia: false,
      logHistoryList: {
        row: {},
        originData: [],
        data: []
      },
      logHistoryParam: {
        pageNo: 1,
        pageSize: 10,
        order: '',
        orderBy: ''
      },
      logHistoryPagerKey: 0,
      confirmDia: false,
      confirmType: '',
      logtailDia: false,
      logtailForm: {
        serverName: '',
        env: '',
        ip: [],
        logPath: '',
        filePattern: '',
        remark: ''
      },
      logtailFormTmp: {},
      logtailRules: {
        serverName: [
          { required: true, message: '请输入服务器名称', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' }
        ],
        env: [{ required: true, message: '请选择环境', trigger: 'blur' }],
        // ip: [{ required: true, message: '请输入IP', trigger: 'blur' }, { validator: IPValidator, trigger: 'blur' }],
        logPath: [{ required: true, message: '请输入日志路径', trigger: 'blur' }],
        // filePattern: [{ required: true, message: '请输入日志路径', trigger: 'blur' }]
        filePattern: [{ validator: filePatternValidator, trigger: 'blur' }]

      },
      logtailList: [],
      logtailListLoading: false,
      logtailTotal: 0,
      ipStatus: "",
      pageSize: 10,
      pageNo: 1,

      devLanguagearr: [],
      devLanguageClientarr: [],
      moneyUnitarr: [],
      productTypearr: [],
      productTimeZonearr: [],


      currentGame: this.$store.state.game.gameOptions.find(item => item.appkey == this.$store.state.game.appkey), // 当前游戏


      createGuidelinesVisible: false,//创建指引
      createGuidelinesList: [
        {
          title: "安装并启动logtail",
          Subtitle: "第一步：",
          html: ''
        },
        {
          title: "配置用户标识和阿里云主账号绑定",
          Subtitle: "第二步：",
          html: ``
        },
        {
          title: "配置机器标识",
          Subtitle: "第三步：",
          html: ""
        }
      ],
      createGuidelinesListLook: [
        {
          title: "安装并启动logtail",
          Subtitle: "第一步：",
          html: ''
        },
        {
          title: "配置用户标识和阿里云主账号绑定",
          Subtitle: "第二步：",
          html: ''
        },
        {
          title: "配置机器标识",
          Subtitle: "第三步：",
          html: ''
        }
      ],
      createGuidelinesActive: 0,

      ipInputVisible: false,
      ipList: [],
      IpHtml: "",

      logCheckTitle: '',
      logCheckVisible: false,
      logCheckList: [],
      logCheckType: '',
      logtailType: 'add',
      currentIndex: 0,



      isFeishu: this.$store.getters.userInfo.attributes.company == "英雄互娱" && this.$store.getters.userInfo.email && this.$store.getters.userInfo.email != '' ? true : false,
      isPhone: this.$store.getters.userInfo.phone && this.$store.getters.userInfo.phone != '' ? true : false,
      isEmail: this.$store.getters.userInfo.email && this.$store.getters.userInfo.email != '' ? true : false,

      // 心跳
      heartbeatForm: {
        id: '',
        appkey: '',
        is_open: true,
        interval: 5,
        intervalUnit: 0,
      },

      // 采集状态
      collectionStatusForm: {
        id: '',
        appkey: '',
        is_open: true,
        interval: 10,
        intervalUnit: 0,
      },

      // 告警设置
      alarmSubmitLoading: false,
      alarmVisible: false,
      alarmForm: {
        id: '',
        appkey: '',
        enabled: 1, // 0 表示开启  1表示关闭
        muteDuration: 30,
        muteDurationUnit: 0,
        alertChannel: [],
      },

      ipTitle: "",
      ipVisible: false,
      ipInfoList: [],
      ipListLoading: false,
      ipRow: {},

      showLogtail: false,
      showLogTime: null,

      // 验证码
      codeVisible: false,
      codePass: 1,
      codePhone: this.$store.getters.userInfo.phone ? this.$store.getters.userInfo.phone.slice(-4) : '',
      codeInput: '',
      codeTimer: null,
      codeTime: 60,

      time1111: new Date().getTime(),
      editLoading: false,
    }
  },

  created() {
    // this.operateStudiolist();
    this.getDictSelect()
    this.productinfodata()
  },
  mounted() {
    this.getlogtailPromptType('create')//创建指引1
    this.getlogtailPromptType('bindAccount')//创建指引2
    this.getlogtailPromptType('createGuide')//查看指引1
    this.getlogtailPromptType('bindAccountGuide')//查看指引2
    this.getlogtailPromptType('getIp')//获取IP说明
  },
  watch: {
    ipList(newValue) {
      this.logtailForm.ip = newValue;
    }
  },
  methods: {
    ipRefresh() {
      // this.showIpInfo(this.ipRow)
      this.ipListLoading = true
      query_logtailIpRefresh({ id: this.ipRow.id }).then(res => {
        if (res.code == 1) {
          this.ipTitle = "IP详情：" + this.ipRow.serverName + (res.data.ipStatus != "" ? " (" + res.data.ipStatus + ")" : "")
          res.data.list.forEach((item, index) => {
            item.xuhaoId = index + 1
          })
          this.ipInfoList = res.data.list
          this.ipListLoading = false
          this.$message({
            type: 'success',
            message: '刷新成功',
            duration: 2000
          })
        }
      })
    },
    // ip详情展示
    showIpInfo(row) {
      if (row.delFlag == 6 || row.delFlag == 0) {
        return false
      }
      this.ipRow = row
      this.ipTitle = "IP详情：" + row.serverName + " (" + row.ipStatus + ")"
      this.ipVisible = true
      this.ipListLoading = true
      query_logtailIp({ id: row.id }).then(res => {
        if (res.code == 1) {
          this.ipTitle = "IP详情：" + row.serverName + (res.data.ipStatus != "" ? " (" + res.data.ipStatus + ")" : "")
          res.data.list.forEach((item, index) => {
            item.xuhaoId = index + 1
          })
          this.ipInfoList = res.data.list
          this.ipListLoading = false
        }
      })
    },
    //心跳提交 采集状态提交
    heartbeatOrcollectionSubmit(type) {
      // 对比频率
      if (!this.frequencyComparison(type)) {
        return false
      }

      query_logtailAlertSavejob({
        id: type == 0 ? this.heartbeatForm.id : this.collectionStatusForm.id,
        appkey: type == 0 ? this.heartbeatForm.appkey : this.collectionStatusForm.appkey,
        interval: type == 0 ? this.heartbeatForm.interval : this.collectionStatusForm.interval,
        intervalUnit: type == 0 ? this.heartbeatForm.intervalUnit : this.collectionStatusForm.intervalUnit,
        taskType: type,
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            type: 'success',
            message: '修改成功',
            duration: 2000
          })
        }
        this.getUpdateFrequency(0)
        this.getUpdateFrequency(1)
      })
    },
    // 频率对比
    frequencyComparison(type) {
      var flag = true
      if (this.heartbeatForm.intervalUnit > this.collectionStatusForm.intervalUnit) {
        flag = false
      }
      if (this.heartbeatForm.intervalUnit == this.collectionStatusForm.intervalUnit) {
        if (this.heartbeatForm.interval >= this.collectionStatusForm.interval) {
          flag = false
        }
      }
      if (this.heartbeatForm.intervalUnit < this.collectionStatusForm.intervalUnit) {
        if (this.heartbeatForm.interval / 60 >= this.collectionStatusForm.interval) {
          flag = false
        }
      }

      if (!flag) {
        this.$message({
          type: 'error',
          dangerouslyUseHTMLString: true,
          message: type == 0 ? 'IP心跳监测的更新频率需 <b>小于</b> IP日志采集状态监测的更新频率，请重新设置' : 'IP日志采集状态监测的更新频率需 <b>大于</b> IP心跳监测的更新频率，请重新设置',
          duration: 5000
        })
        return false
      } else {
        return true
      }
    },

    //告警设置
    alarmSet() {
      this.alarmVisible = true
      this.alarmGet()
    },
    //告警设置
    alarmGet() {
      query_logtailAlertRule({}).then(res => {
        if (res.code == 1) {
          if (res.data) {
            res.data.alertChannel = res.data.alertChannel == "" ? [] : res.data.alertChannel.split(',')
            this.alarmForm = res.data
          } else {
            this.alarmForm = {
              id: '',
              appkey: '',
              enabled: 1, // 0 表示开启  1表示关闭
              muteDuration: 30,
              muteDurationUnit: 0,
              alertChannel: [],
            }
          }
        }
      })
    },
    alarmGuanbi() {
      this.alarmVisible = false
      this.alarmGet()
    },
    enabledChange(e) {
      if (e == 1) {
        this.alarmForm.alertChannel = []
      }
    },
    // 告警设置提交
    alarmSubmit() {
      console.log(this.alarmForm)
      if (this.alarmForm.enabled == 0 && (this.alarmForm.alertChannel == null || this.alarmForm.alertChannel.length == 0)) {
        this.$message({
          type: 'error',
          message: '请选择告警方式',
          duration: 2000
        })
        return false
      }
      this.alarmSubmitLoading = true
      query_logtailAlertSave({
        id: this.alarmForm.id,
        appkey: this.alarmForm.appkey ? this.alarmForm.appkey : this.$store.state.game.appkey,
        enabled: this.alarmForm.enabled,
        muteDuration: this.alarmForm.muteDuration,
        muteDurationUnit: this.alarmForm.muteDurationUnit,
        alertChannel: this.alarmForm.alertChannel.join(','),
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            type: 'success',
            message: '修改成功',
            duration: 2000
          })
          this.alarmVisible = false
        }
        this.alarmSubmitLoading = false
      })
    },
    // 获取更新频率
    getUpdateFrequency(taskType) {
      query_logtailAlertGetjob({ taskType: taskType }).then(res => {
        if (res.code == 1 && res.data) {
          if (taskType == 0) {
            this.heartbeatForm = {
              id: res.data.id,
              appkey: res.data.appkey,
              is_open: true,
              interval: res.data.interval,
              intervalUnit: res.data.intervalUnit,
              taskType: 0
            }
          } else if (taskType == 1) {
            this.collectionStatusForm = {
              id: res.data.id,
              appkey: res.data.appkey,
              is_open: true,
              interval: res.data.interval,
              intervalUnit: res.data.intervalUnit,
              taskType: 1
            }
          }
        }
      })
    },
    getBdcGuideSrcdoc(html) {
      if (!html) return html || ''
      const bdcGuideStyle = [
        '<style>',
        'button,input[type="button"],input[type="submit"],.el-button,.copy-btn,a[role="button"]{',
        'background:#6979F8!important;color:#fff!important;border:1px solid #6979F8!important;',
        'border-radius:6px!important;padding:4px 12px!important;',
        'font-size:13px!important;font-weight:500!important;',
        'cursor:pointer!important;box-shadow:none!important;outline:none!important;',
        '}',
        'button:hover,input[type="button"]:hover,input[type="submit"]:hover,.el-button:hover{',
        'background:#5a6ae8!important;border-color:#5a6ae8!important;color:#fff!important;',
        '}',
        '</style>'
      ].join('')
      if (/<head[^>]*>/i.test(html)) {
        return html.replace(/<head([^>]*)>/i, `<head$1>${bdcGuideStyle}`)
      }
      if (/<html[^>]*>/i.test(html)) {
        return html.replace(/<html([^>]*)>/i, `<html$1><head>${bdcGuideStyle}</head>`)
      }
      return `${bdcGuideStyle}${html}`
    },
    // 获取logtail信息
    getlogtailPromptType(type) {
      logtailPromptType({ promptType: type }).then(res => {
        if (res.code == 1) {
          if (type == 'createGuide') {
            this.createGuidelinesListLook[0].html = res.data[0];
          } else if (type == 'bindAccountGuide') {
            this.createGuidelinesListLook[1].html = res.data[0];
          } else if (type == 'create') {
            this.createGuidelinesList[0].html = res.data[0];
          } else if (type == 'bindAccount') {
            this.createGuidelinesList[1].html = res.data[0];
          } else if (type == 'getIp') {
            this.IpHtml = res.data[0];
          } else if (type == 'errorReason') {
            res.data.forEach(item => {
              this.logCheckList.push({
                html: item
              })
            })
          } else if (type == 'errorCheck') {
            res.data.forEach(item => {
              this.logCheckList.push({
                html: item
              })
            })
          }
        }
      })
    },
    copyIp($event) {
      clipboard(String(this.textStr), $event)
    },
    // 添加IP
    showIpInput() {
      // if (this.logtailType == 'add') {
      this.ipInputVisible = true
      console.log(this.ipList)
      this.textStr = this.ipList.join('\n')
      // }
    },
    // 关闭IP
    closeIpInput() {
      // var strArr = Array.from(new Set(this.textStr.split(/[(\r\n)\r\n]+/)))
      // if (strArr.length > 100) {
      //   this.$message({
      //     message: '超过100条将截取去重后的前100条',
      //     type: 'warning',
      //     offset: 100
      //   })
      //   strArr = strArr.slice(0, 100)
      // }
      // if (this.ipValidate(strArr)) {
      this.ipInputVisible = false
      // }
    },
    querenIpInput() {
      var strArr = Array.from(new Set(this.textStr.split(/[(\r\n)\r\n]+/)))
      if (strArr.length > 100) {
        this.$message({
          message: '超过100条将截取去重后的前100条',
          type: 'warning',
          offset: 100,
        })
        strArr = strArr.slice(0, 100)
      }
      if (this.ipValidate(strArr)) {
        this.ipInputVisible = false
      }
    },
    handleCloseTag(tag) {
      this.ipList.splice(this.ipList.indexOf(tag), 1);
    },
    // 添加logtail配置
    addLogtail() {
      this.logtailType = 'add'
      this.createGuidelinesActive = 0
      this.ipList = []
      this.textStr = ""
      // this.productinfodata()
      this.logtailDia = true
      Object.keys(this.logtailForm).forEach(key => {
        this.logtailForm[key] = ''
      })
      this.logtailFormTmp = {}
      this.$nextTick(() => {
        this.$refs.logtailFormRef && this.$refs.logtailFormRef.clearValidate()
      })
      // this.logtailForm = this.$options.data().logtailForm
    },

    // 刷新
    refresh() {
      this.$message({
        message: '刷新成功',
        type: 'success'
      })
      this.getLogtailList()
    },

    // 检测logtail采集状态
    checkLogtail(row) {
      logtailCollectStatus({
        id: row.id,
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            message: '已完成检测',
            type: 'success'
          })
          this.getLogtailList()
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    // 创建或采集失败信息
    showErrorInfo(row, type) {
      this.logCheckType = type
      this.currentIndex = 0
      if (type == "errorReason") {
        this.logCheckTitle = "创建失败原因"
        this.logCheckList = []
        this.getlogtailPromptType('errorReason')//创建失败错误原因
      } else {
        this.logCheckTitle = "未检测到日志的常见原因"
        this.logCheckList = []
        this.getlogtailPromptType('errorCheck')//未检测到日志的常见原因
      }
      this.logCheckVisible = true
    },

    // 编辑logtail
    editLogtail(row) {
      console.log(row)
      this.logtailType = "edit"
      this.createGuidelinesActive = 2;
      this.logtailFormTmp = JSON.parse(JSON.stringify(row || {}))
      this.logtailForm = JSON.parse(JSON.stringify(row || {}))
      this.ipList = this.logtailForm.ip
      this.logtailDia = true
      this.$nextTick(() => {
        this.$refs.logtailFormRef && this.$refs.logtailFormRef.clearValidate()
      })
    },

    // 删除logtail
    delLogtail(row) {
      this.confirmDia = true
      this.confirmType = JSON.parse(JSON.stringify(row || {}))
    },

    // logtail变更历史
    logtailHistory(row) {
      this.logHistoryParam.pageNo = 1
      this.logHistoryPagerKey += 1
      this.logHistoryDia = true
      this.logHistoryList.row = row
      query_logtailHistory(row).then(res => {
        if (res.code == 1) {
          this.logHistoryList.originData = res.data
          this.getLogtailHistory()
        }
      })
    },

    // 获取logtail变更历史数据
    getLogtailHistory(payload) {
      if (payload) {
        this.logHistoryParam.pageNo = payload.page
        this.logHistoryParam.pageSize = payload.limit
      }
      // console.log(this.logHistoryParam)
      if (this.logHistoryParam.order) {
        const order = this.logHistoryParam.order != 'descending'
        this.logHistoryList.originData.sort(sortKeys(this.logHistoryParam.orderBy, order))
      } else {
        this.logHistoryList.originData = JSON.parse(JSON.stringify(this.logHistoryList.originData))
      }
      const start = (this.logHistoryParam.pageNo - 1) * this.logHistoryParam.pageSize
      const end = start + this.logHistoryParam.pageSize
      this.logHistoryList.data = this.logHistoryList.originData.slice(start, end)
    },

    // logtail变更历史排序
    logHistorySort(param) {
      this.logHistoryParam.order = param.order
      this.logHistoryParam.orderBy = param.prop
      this.getLogtailHistory()
    },

    // 校验ip
    ipValidate(arr) {
      const ip_ip = '(25[0-5]|2[0-4]\\d|1\\d\\d|\\d\\d|\\d)'
      const ip_ipdot = ip_ip + '\\.'
      const isIPaddress = new RegExp('^' + ip_ipdot + ip_ipdot + ip_ipdot + ip_ip + '$')
      let ipList = arr
      if (this.ipInputVisible) {
        for (var i in ipList) {
          if (!isIPaddress.test(ipList[i].replace('\r', "").replace('\n', "").replace('\r\n', ""))) {
            this.$message({
              message: 'IP地址格式错误',
              type: 'error'
            })
            return false;
          }
        }
        this.ipList = ipList
        return true;
      }
    },

    // 提交logtail创建
    handleCreateLogtail() {
      if (this.ipList.length == 0) {
        this.$message({
          message: '请添加IP地址',
          type: 'error'
        })
        return false;
      }
      this.$refs.logtailFormRef.validate(valid => {
        if (valid) {
          this.editLoading = true
          add_logtail(this.logtailForm).then(res => {
            if (res.code == 1) {
              this.$message({
                message: 'logtail配置创建中，大约2分钟后可刷新查看创建结果',
                type: 'success'
              })
              this.logtailDia = false
              this.getLogtailList()
            }
            this.editLoading = false

          })
        }
      })
    },
    clickStep(index) {
      this.createGuidelinesActive = index
    },
    //上一步
    prevSteps() {
      this.createGuidelinesActive--
    },
    //下一步
    nextSteps() {
      this.createGuidelinesActive++
    },
    // 取消创建
    cancelLogtailDia() {
      this.logtailDia = false;
      this.logtailForm = {
        serverName: '',
        env: '',
        ip: [],
        logPath: '',
        filePattern: '',
        remark: ''
      }
    },

    // 数组对比
    compareArraysWithoutOrder(array1, array2) {
      // 首先，将两个数组都转换为Set，这样可以自动去重
      const set1 = new Set(array1);
      const set2 = new Set(array2);

      // 比较两个Set的大小是否相同
      if (set1.size !== set2.size) {
        return false;
      }

      // 使用Set的has方法来检查一个Set是否包含另一个Set的所有元素
      for (let value of set1) {
        if (!set2.has(value)) {
          return false;
        }
      }

      // 如果上面的循环完成而没有返回false，则说明两个数组的值是一致的（不考虑顺序）
      return true;
    },

    // 修改前的确认
    handelEditConfirm(handle = false) {
      if (this.ipList.length == 0) {
        this.$message({
          message: '请添加IP地址',
          type: 'error'
        })
        return false;
      }
      this.$refs['logtailFormRef'].validate(valid => {
        if (valid) {
          // if (this.logtailFormTmp.ip != this.logtailForm.ip && !handle) {
          // if (this.logtailFormTmp.logPath != this.logtailForm.logPath && !handle) {
          //   this.confirmType = 'edit'
          //   this.confirmDia = true
          // } else if (this.logtailFormTmp.filePattern != this.logtailForm.filePattern && !handle) {
          //   this.confirmType = 'edit'
          //   this.confirmDia = true
          // } else 
          if (!this.compareArraysWithoutOrder(this.logtailFormTmp.ip, this.logtailForm.ip) && !handle) {
            this.confirmType = 'edit'
            this.confirmDia = true
          } else {
            this.editLoading = true
            edit_logtail(this.logtailForm).then(res => {
              if (res.code == 1) {
                this.editLoading = false
                this.$message({
                  message: '编辑成功',
                  type: 'success'
                })
                this.logtailDia = false
                this.confirmDia = false
                this.getLogtailList()
              }
            })
          }
        }
      })
    },

    // 确认删除logtail
    handleDelLogtail(row) {
      delete_logtail(row).then(res => {
        if (res.code == 1) {
          this.$message({
            message: '停止成功',
            type: 'success'
          })
          this.logtailDia = false
          this.confirmDia = false
          this.getLogtailList()
        }
      })
    },

    // 查看详情
    seeDetail() {
      this.$refs['create'].lookInit(this.form.id, true)
    },
    // 校验logtail
    showLogtailClick() {

      this.codeVisible = true
      this.codeInput = ''
      this.codePass = 1
      if (this.codeTime == 60) {
        this.getCode()
      }
    },
    // 获取验证码
    getCode() {
      this.codePass = 1
      if (this.codeTime == 60) {
        this.codeTimer = setInterval(() => {
          this.codeTime--
          if (this.codeTime == 0) {
            clearInterval(this.codeTimer)
            this.codeTimer = null
            this.codeTime = 60
          }
        }, 1000)
      }
      gameSendCode(
        {
          type: this.codePhone != '' ? 'sms' : 'email',
        }
      ).then(res => {
        if (res.code == 1) {
          this.$message({
            message: '验证码发送成功',
            type: 'success'
          })
        }
      })
    },

    // 提交验证验证码
    codeSubmit() {
      if (this.codeInput == '') {
        this.$message({
          message: '请输入验证码',
          type: 'error'
        })
        return false
      }
      gameVerifyCode(
        {
          type: this.codePhone != '' ? 'sms' : 'email',
          code: this.codeInput
        }
      ).then(res => {
        if (res.code == 1) {
          this.$message({
            message: '验证成功',
            type: 'success'
          })
          this.codeVisible = false
          this.codeInput = ''
          this.codeTime = 60
          clearInterval(this.codeTimer)
          this.codeTimer = null

          this.form = res.data
          if (this.form.ttl && this.form.ttl > 0) {
            this.showLogtail = true
            this.countDown()
          } else {
            this.showLogtail = false
          }
        }
        this.codePass = res.code
      })
    },

    // 倒计时
    countDown() {
      if (this.form.ttl && this.form.ttl > 0) {
        this.showLogtail = true
        this.showLogTime = setInterval(() => {
          this.form.ttl--
          if (this.form.ttl && this.form.ttl <= 0) {
            clearInterval(this.showLogTime)
            this.showLogTime = null;
            this.showLogtail = false
            this.productinfodata()
          }
        }, 1000)
      } else {
        this.showLogtail = false
      }
    },
    // 获取
    productinfodata() {
      productinfo().then(response => {
        if (response.code == 1) {
          this.form = response.data
          if (this.form.ttl && this.form.ttl > 0) {
            this.showLogtail = true
            this.countDown()
          } else {
            this.showLogtail = false
          }
          this.getLogtailList()
        } else {
          this.$message({
            type: 'warning',
            message: response.msg
          })
        }
      })
    },

    // 获取logtail列表
    getLogtailList(refreshMonitor = true) {
      if (this.currentGame.eventTrackVersion == 'v2.0' && this.form.openLogtail) {
        if (refreshMonitor) {
          this.getUpdateFrequency(0)//获取更新频率
          this.getUpdateFrequency(1)//获取更新频率
          this.alarmGet()
        }
        this.logtailListLoading = true
        query_logtail(
          {
            delFlag: this.ipStatus,
            pageNo: this.pageNo,
            pageSize: this.pageSize
          }
        ).then(res => {
          if (res.code == 1) {
            this.logtailList = res.data.records
            this.logtailTotal = res.data.total
          }
        }).finally(() => {
          this.logtailListLoading = false
        })
      }
    },

    handleLogtailPagination({ page, limit }) {
      const pageSizeChanged = limit !== this.pageSize
      this.pageSize = limit
      this.pageNo = pageSizeChanged ? 1 : page
      this.getLogtailList(false)
    },
    handlePageSize(e) {
      // table 分页数量变化
      this.pageSize = e
      this.getLogtailList()
    },
    handlePageNo(e) {
      // table 分页变化
      this.pageNo = e
      this.getLogtailList()
    },

    // 表格有筛选的数据变化
    filterChange(filters) {
      var filtersJSON = JSON.parse(JSON.stringify(filters))
      this.ipStatus = filtersJSON.ipStatus.join(',')
      this.pageNo = 1
      this.getLogtailList()
    },

    // 开启logtail
    openLogtail(val) {
      if (!val) {
        query_logtailIsClosed({}).then(res1 => {
          if (res1.code == 1) {
            if (res1.data) {
              open_logtail({ openLogtail: val }).then(res => {
                if (res.code == 1) {
                  this.$message({
                    type: 'success',
                    message: this.form.openLogtail == true ? '开启logtail成功' : '关闭logtail成功'
                  })
                  this.getLogtailList()
                } else {
                  this.form.openLogtail = !val
                }
              })
            } else {
              this.guanbiDia = true
              this.form.openLogtail = !val
            }
          }
        })
      } else {
        open_logtail({ openLogtail: val }).then(res => {
          if (res.code == 1) {
            this.$message({
              type: 'success',
              message: this.form.openLogtail == true ? '开启logtail成功' : '关闭logtail成功'
            })
            this.getLogtailList()
          } else {
            this.form.openLogtail = !val
          }
        })
      }
    },

    // 复制
    copy($event, value) {
      clipboard(value, $event)
    },

    // logTail详情
    logDetail() {
      window.open('https://help.aliyun.com/document_detail/28979.html', '_blank')
    },

    logUploadDoc() {
      window.open('https://help.aliyun.com/zh/sls/import-historical-logs?scm=20140722.S_help%40%40%E6%96%87%E6%A1%A3%40%4071414._.ID_help%40%40%E6%96%87%E6%A1%A3%40%4071414-RL_%E5%8E%86%E5%8F%B2-LOC_doc%7EUND%7Eab-OR_ser-PAR1_212a5d4017557824253143967dd8d5-V_4-PAR3_r-RE_new5-P0_3-P1_0&spm=a2c4g.11174283.help-search.i20', '_blank')
    },

    dataURItoBlob(base64Data) {
      let byteString = base64Data
      if (base64Data.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(base64Data.split(',')[1]) // base64 解码
      } else {
        byteString = unescape(base64Data.split(',')[1])
      }
      // 获取文件类型
      const mimeString = base64Data.split(',')[0].match(/:(.*?);/)[1] // mime类型

      const uintArr = new Uint8Array(byteString.length) // 创建视图

      for (let i = 0; i < byteString.length; i++) {
        uintArr[i] = byteString.charCodeAt(i)
      }
      // 生成blob图片
      const blob = new Blob([uintArr], {
        type: mimeString
      })
      console.log(uintArr, blob)
      // 使用 Blob 创建一个指向类型化数组的URL, URL.createObjectURL是new Blob文件的方法,可以生成一个普通的url,可以直接使用,比如用在img.src上
      return URL.createObjectURL(blob)
    },

    // 获取所有字典下拉
    getDictSelect() {
      // 服务端开发语言
      productinfovalue('devLanguage').then(response => {
        if (response.code == 1) {
          this.devLanguagearr = response.data
        }
      })
      // 客户端开发语言
      productinfovalue('devLanguageClient').then(
        response => {
          if (response.code == 1) {
            this.devLanguageClientarr = response.data
          }
        }
      )
      // 货币单位
      productinfovalue('moneyUnit').then(response => {
        if (response.code == 1) {
          this.moneyUnitarr = response.data
        }
      })
      // 应用类型
      productinfovalue('sasProductType').then(response => {
        if (response.code == 1) {
          this.productTypearr = response.data
        }
      })
      // 时区
      productinfovalue('productTimeZone').then(response => {
        if (response.code == 1) {
          this.productTimeZonearr = response.data
        }
      })
    },


    // 查看创建指引
    showCreateGuidelines() {
      this.createGuidelinesVisible = true
    },
  },
  beforeDestroy() {
    clearInterval(this.showLogTime)
    clearInterval(this.codeTimer)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.ifSls {
  ::v-deep .el-input__inner {
    text-decoration: line-through;
  }
}

::v-deep .el-dialog__body {
  padding: 30px 20px;
}

.app-container:not(.bdc-list-page):not(.bdc-app-manage-page) {
  padding: 20px 24px;
  background: #f0f2f5;
  min-height: calc(100vh - 84px);

  .app-title {
    padding: 24px;
    background: #fff;
    border-radius: 4px;
    height: 120px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .chart-container {
    position: relative;
    padding: 24px;
    border-radius: 4px;
    background: #fff;
  }
}

.app-container.bdc-list-page {
  padding: 0 !important;
  background: transparent !important;
  min-height: 0 !important;
}

.ibox-title:not(.bdc-app-manage-section-head) {
  line-height: 32px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

/* .grid-content  */
.ibox-content {
  border: none;
}

.ibox-title h5 {
  margin: 0;
}

.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}

.custom-label {
  ::v-deep .el-form-item__label {
    line-height: 15px;

    .label-title {
      display: block;
      color: #666;
      line-height: 20px;
    }

    .label-text {
      font-size: 12px;
      color: #999;
    }
  }
}

/* .el-table th{background:#fff;} */
.drawerFooter {
  padding: 10px 22px 0px 22px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

::v-deep .el-drawer__header {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 22px;

  span:focus {
    outline: 0;
  }
}

.centerAlert {
  ::v-deep .el-alert__description {
    font-size: 14px;
  }

  ::v-deep .el-alert__icon {
    margin-top: -18px;
    font-size: 16px !important;
    width: 16px !important;
  }
}

.centerAlert1 {
  ::v-deep .el-alert__description {
    font-size: 14px;
  }

  ::v-deep .el-alert__icon {
    /* // margin-top: 3px; */
    font-size: 16px !important;
    width: 16px !important;
  }
}

.rightAlert {
  ::v-deep .el-alert__title {
    font-size: 14px;
  }

  ::v-deep .el-alert__icon {
    /* // margin-top: -18px; */
  }
}

::v-deep .el-alert--warning.is-light {
  background: rgba(255, 150, 62, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(255, 150, 62, 0.1);

  .el-alert__description {
    color: #ff963e;
    margin: 0 0 0 0;
  }

  .el-icon-warning {
    color: #ff963e;
  }

  .el-alert__content {
    color: #ff963e;
  }
}

::v-deep .el-step__title {
  font-size: 14px;
  color: #333333;
  font-weight: 400;
}

::v-deep .el-step__title.is-success {
  color: #3a89ff;
}

::v-deep .el-step__head.is-success {
  color: #3a89ff;
  border-color: #3a89ff;
}

::v-deep .el-step__head.is-process {
  color: #fff;
  border-color: #3a89ff;

  .el-step__icon {
    background: #3a89ff;
  }
}

::v-deep .el-step__head.is-wait {
  color: #c0c4cc;
  border-color: #c0c4cc;

  .el-step__icon {
    background: #fff;
  }
}

.ipInput {
  width: 570px;
  position: relative;
  min-height: 36px;
  line-height: 36px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  background-color: #fff;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  padding: 0 15px;
  border-radius: 4px;
}

.ipTag {
  ::v-deep .el-tag {
    background: rgba(58, 137, 255, 0.1);
    border-color: #d8e7ff;
    display: inline-block;
    height: 24px;
    padding: 0 8px;
    line-height: 24px;
    font-size: 14px;
    color: #333333;
    box-sizing: border-box;
    white-space: nowrap;
  }
}
</style>

<style>
.el-tabs__header {
  margin-bottom: 0px;
}

.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}

.el-row {
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #fff;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}

.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}

.el-table--medium td,
.el-table--medium th {
  padding: 6px;
}

.el-table th {
  background-color: #fff;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  /* // margin-top: 18px; */
  .card-panel-col {
    /* // margin-bottom: 32px; */
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shoppingCard {
        background: #34bfa3;
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shoppingCard {
      color: #34bfa3;
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

.icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 12px;
}

.icon-box {
  width: 36px;
  height: 36px;
  padding: 10px;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  display: flex;
  justify-content: center;
  align-items: center;

  .icon {
    width: 16px;
    height: 16px;
    margin-left: 0px;
  }
}
</style>
<style>
.aaa {
  text-align: center;
}

.shishitophuizong {
  width: 16.6%;
  float: left;
  text-align: center;
}

.shishitophuizong1 {
  font-size: 14px;
  font-weight: 600;
  padding: 5px 0px;
}

.shishitophuizong2 {
  font-size: 30px;
  font-weight: 100;
  padding: 5px 0px;
}

.shishitophuizong3 {
  font-size: 12px;
  font-weight: 100;
  padding: 5px 0px;
}

.shishitophuizong1 icon {
  width: 15px;
  height: 15px;
}

.shishitophuizonger {
  width: 16.6%;
  float: left;
  text-align: center;
  border-top: 1px solid #e7eaec;
  padding: 8px 0px;
  vertical-align: middle;
  color: #337ab7;
  font-size: 14px;
}

body:not(.bdc-app-body) .el-tag {
  background: none;
  border: none;
}

.zhibiaoshuoming {
  font-size: 12px;
  color: #999;
}

.zhibiaoshuoming_title {
  font-size: 14px;
  color: #666;
  display: block;
  border-bottom: 1px solid #dedede;
  padding-bottom: 10px;
}

.el-loading-mask {
  z-index: 5;
}

.disqudao {
  display: none;
}

.tianjiastyle,
.tianjiastyle1 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}

.tianjiastyle_bg,
.tianjiastyle_bg1 {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
}

.tianjiastyle_content {
  width: 720px;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 50%;
  margin-left: -350px;
  border: 1px solid #dedede;
}

.tianjiastyle_content1 {
  width: 90%;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 5%;
  border: 1px solid #dedede;
}

.yyform .el-form-item__label {
  font-size: 14px;
  font-weight: 400;
  color: #666;
}

.yindaodiv {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(0, 0, 0, 0.2);
  z-index: 99999;
}
</style>